import AvailableStudentsListItem from './available-students-list-item'

export default AvailableStudentsListItem
